<template>
  <div class="container">

    <heading-one class="-margin-md">審査結果のご確認</heading-one>

    <notice-box class="-cancel _mb-md-120 _mb-sm-60">
      <notice-header class="-textleft">
        <h2 class="heading">このたびは、au PAY スマートローンにお申し込みいただき、誠にありがとうございます。</h2>
      </notice-header>
      <notice-body class="-textleft">
        <p>お申し込みの際にご入力いただいた内容および弊社が加盟する指定信用情報機関、弊社が保有する情報などを参考に、弊社審査基準により判断させていただき、誠に申し訳ございませんが、今回はご契約を見送らせていただく結果となりました。</p>
        <p>ご希望に添えず誠に恐縮ではございますが、何卒ご了承くださいますようお願い申し上げます。</p>
      </notice-body>
    </notice-box>

  </div><!-- container -->
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import NoticeHeader from '../components/box/NoticeHeader'

export default {
  name: 'En-011',
  metaInfo: {
    title: '審査結果のご確認',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果'}
    ]
  },
  components: {
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    HeadingOne
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/En011.vue